module.exports = __webpack_public_path__ + "static/media/logo-camarasenhorbonfim.3b75cbc0.png";